module.exports = __webpack_public_path__ + "img/treatments-directory-dashboard-mobile-fr.48fc78f2.jpg";